<template>
  <el-dialog
    title="选择教练"
    :visible.sync="dialogVisible"
    width="80%"
    :close-on-click-modal="false"
    @close="handleClose"
  >
    <!-- 搜索筛选区域 -->
    <el-form :inline="true" class="search-form">
      <el-form-item label="姓名">
        <el-input 
          v-model="searchForm.real_name" 
          placeholder="请输入姓名"
          clearable
          style="width: 150px"
        ></el-input>
      </el-form-item>
      
      <el-form-item label="电话">
        <el-input 
          v-model="searchForm.phone" 
          placeholder="请输入电话"
          clearable
          style="width: 150px"
        ></el-input>
      </el-form-item>
      
      <el-form-item label="性别">
        <el-select 
          v-model="searchForm.sex" 
          placeholder="请选择"
          clearable
          style="width: 120px"
        >
          <el-option label="男" value="男"></el-option>
          <el-option label="女" value="女"></el-option>
        </el-select>
      </el-form-item>

       <el-form-item label="类型">
        <el-select 
          v-model="searchForm.coach_type" 
          placeholder="请选择"
          clearable
          style="width: 120px"
        >
          <el-option label="教练" value="coach"></el-option>
          <el-option label="达人" value="expert"></el-option>
          <el-option label="顾问" value="consu"></el-option>
        </el-select>
      </el-form-item>
      
      <el-form-item label="城市">
        <city-select 
          @change="handleCityChange" 
          :temp="cityList"
          placeholder="选择城市"
        ></city-select>
      </el-form-item>
      
      <el-form-item label="类目">
        <el-select 
          v-model="searchForm.teaching_categories" 
          placeholder="请选择类目"
          clearable
          style="width: 150px"
        >
          <el-option 
            v-for="item in teaching_categoriesList" 
            :key="item.id" 
            :label="item.name" 
            :value="item.name"
          ></el-option>
        </el-select>
      </el-form-item>
      
      <el-form-item label="标签">
        <el-input 
          v-model="searchForm.tags" 
          placeholder="请输入标签"
          clearable
          style="width: 150px"
        ></el-input>
      </el-form-item>
      
      <el-form-item>
        <el-button type="primary" @click="handleSearch">搜索</el-button>
        <el-button @click="handleReset">重置</el-button>
      </el-form-item>
    </el-form>

    <!-- 教练列表表格 -->
    <el-table
      :data="coachList"
      v-loading="loading"
      border
      stripe
      highlight-current-row
      @current-change="handleCurrentChange"
      style="width: 100%; margin-top: 10px"
    >
      <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
      
      <el-table-column label="头像" width="80" align="center">
        <template slot-scope="{ row }">
          <el-avatar :src="row.avatar || defaultAvatar" size="small"></el-avatar>
        </template>
      </el-table-column>
      
      <el-table-column prop="real_name" label="姓名" width="100" align="center">
         <template slot-scope="{ row }">
         <div>
          {{row.real_name || row.name}}
         </div>
        </template>
      </el-table-column>
      
      <el-table-column prop="phone" label="电话" width="120" align="center"></el-table-column>
      
      <el-table-column prop="sex" label="性别" width="60" align="center">
         <template slot-scope="{ row }">
         <div>
          {{row.sex == 1 ? '男' : '女'}}
         </div>
        </template>
      </el-table-column>
      
      <el-table-column label="城市" width="150" align="center">
        <template slot-scope="{ row }">
         {{ row.city }}- {{ row.district }} 
         <div>
          {{row.distance_service}}公里内可服务
         </div>
        </template>
      </el-table-column>
      
      <el-table-column label="类目" min-width="120" align="center">
        <template slot-scope="{ row }">
          <el-tag size="small" v-if="row.teaching_categories">{{ row.teaching_categories }}</el-tag>
          <span>{{row.teaching_age}}年</span>
        </template>
      </el-table-column>
      <el-table-column label="类目" min-width="120" align="center">
        <template slot-scope="{ row }">
         {{row.min_price}}元起
        </template>
      </el-table-column>
      
      <el-table-column label="信息" align="center">
        <template slot-scope="{ row }">
          <span class="m-r10">{{levelMap[row.coach_level] || '初级'}}</span>
           <span class="hei-tag" v-if="row.date_birth">
							{{calculateCoachAge(row.date_birth)}}岁
						</span>
            <span class="m-r10">{{row.hei}}cm</span>
            <span class="m-r10">{{row.wei}}kg</span>
        </template>
      </el-table-column>
      
      <el-table-column label="标签" min-width="150" align="center">
        <template slot-scope="{ row }">
          <el-tag 
            v-for="(tag, index) in getTags(row)" 
            :key="index" 
            size="mini" 
            style="margin-right: 5px"
          >
            {{ tag }}
          </el-tag>
          <span v-if="!row.tags || row.tags === ''">-</span>
        </template>
      </el-table-column>
      
      <el-table-column label="操作" width="100" align="center" fixed="right">
        <template slot-scope="{ row }">
          <el-button 
            type="primary" 
            size="small" 
            @click="handleSelectCoach(row)"
          >
            选择
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <el-pagination
      v-if="total > 0"
      @current-change="handlePageChange"
      :current-page="currentPage"
      :page-size="pageSize"
      :total="total"
      layout="total, prev, pager, next, jumper"
      style="margin-top: 20px; text-align: right"
    >
    </el-pagination>

    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
    </span>
  </el-dialog>
</template>

<script>
import citySelect from '@/components/select/citySelect.vue';
import {
		calculateAge
	} from '@/utils/utils.js';
export default {
  name: 'CoachSelectDialog',
  components: {
    citySelect
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      levelMap: {
					'0': '新手',
					'1': '初级',
					'2': '中级',
					'3': '高级',
					'4': '特级'
				},
      dialogVisible: false,
      loading: false,
      coachList: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      currentCoach: null,
      defaultAvatar: '',
      
      // 搜索表单
      searchForm: {
        real_name: '',
        phone: '',
        sex: '',
        province: '',
        city: '',
        district: '',
        teaching_categories: '',
        tags: '',
        status: 2
      },
      
      // 城市列表
      cityList: [],
      
      // 类目列表
      teaching_categoriesList: []
    };
  },
  
  created() {
    this.getCategoryList();
  },
  watch: {
    visible(val) {
      this.dialogVisible = val;
      if (val) {
        this.getCoachList();
      }
    },
    dialogVisible(val) {
      this.$emit('update:visible', val);
    }
  },
  
  methods: {
    calculateCoachAge(v){
				return calculateAge(v)
			},
    // 获取教练列表
    getCoachList() {
      this.loading = true;
      
      const params = {
        currentPage: this.currentPage,
        pageSize: this.pageSize,
        status: 2, // 只查询在职教练
        ...this.searchForm
      };
      
      // 清除空值
      Object.keys(params).forEach(key => {
        if (params[key] === '' || params[key] === null || params[key] === undefined) {
          delete params[key];
        }
      });
      
      this.$axios({
        url: '/user/coach/queryManagerListPage',
        method: 'get',
        params: params
      }).then(res => {
        this.loading = false;
        if (res.data.code === 0) {
          this.coachList = res.data.data.rows || [];
          this.total = res.data.data.total || 0;
        } else {
          this.$message.error(res.data.message || '获取教练列表失败');
        }
      }).catch(err => {
        this.loading = false;
        this.$message.error('网络错误，请稍后重试');
        console.error('获取教练列表失败:', err);
      });
    },
    
    // 获取类目列表
    getCategoryList() {
      let url = "/user/mechanismCategory/queryListPageChild";
      let data = {
        status: 2,
        type: 2,
        source: '课程'
      };
      this.$axios
        .get(url, {
          params: data,
        })
        .then((res) => {
          if (res.data.code === 0) {
            this.teaching_categoriesList = res.data.data || [];
          }
        })
        .catch(err => {
          console.error('获取类目列表失败:', err);
        });
    },
    
    // 搜索
    handleSearch() {
      this.currentPage = 1;
      this.getCoachList();
    },
    
    // 重置
    handleReset() {
      this.searchForm = {
        real_name: '',
        phone: '',
        sex: '',
        province: '',
        city: '',
        district: '',
        teaching_categories: '',
        tags: ''
      };
      this.cityList = [];
      this.currentPage = 1;
      this.getCoachList();
    },
    
    // 城市选择变化
    handleCityChange(cityData) {
      this.searchForm.province = cityData.province || '';
      this.searchForm.city = cityData.city || '';
      this.searchForm.district = cityData.district || '';
      this.cityList = [
        cityData.province || '',
        cityData.city || '',
        cityData.district || ''
      ];
    },
    
    // 分页变化
    handlePageChange(page) {
      this.currentPage = page;
      this.getCoachList();
    },
    
    // 表格行选中
    handleCurrentChange(row) {
      this.currentCoach = row;
    },
    
    // 选择教练
    handleSelectCoach(coach) {
      this.$emit('select', coach);
      this.dialogVisible = false;
    },
    
    // 关闭对话框
    handleClose() {
      this.handleReset();
    },
    
    // 获取标签数组
    getTags(row) {
      if (!row.tags) return [];
      return row.tags.split(',').filter(tag => tag.trim());
    },
    
    // 打开对话框（供父组件调用）
    open() {
      this.dialogVisible = true;
    }
  }
};
</script>

<style lang="less" scoped>
.search-form {
  margin-bottom: 10px;
}

::v-deep .el-table {
  .el-table__header-wrapper {
    th {
      background-color: #f5f7fa;
      color: #606266;
      font-weight: bold;
    }
  }
  
  .el-table__row {
    &:hover {
      cursor: pointer;
    }
  }
}

.dialog-footer {
  text-align: right;
}
</style>
